// Lead Detail — right column: Quick Actions, Move Stage, Lead Score.
import React, { Component } from "react";
import ReactDOM from "react-dom";
import HelperClass from "../../../../config/helperClass";
import { archiveLead, listStages, updateStage, getScoreWeights } from "../api/leads_api";
import { safeJson, scoreBand } from "./helpers";

const auth = new HelperClass();

const FACTOR_LABELS = {
  engagement:        "Engagement",
  deal_value:        "Deal Value",
  stage_progression: "Stage Progression",
  activity_recency:  "Activity Recency",
  priority:          "Priority",
};
const FACTOR_DEFAULT_WEIGHTS = {
  engagement: 30, deal_value: 25, stage_progression: 20, activity_recency: 15, priority: 10,
};

export default class RightPanel extends Component {
  state = { stages: [], movingTo: null, weights: FACTOR_DEFAULT_WEIGHTS, weightsLoaded: false, showArchiveModal: false, archiving: false };

  componentDidMount() {
    this.loadStages();
    this.loadWeights();
    this._onKeyDown = (e) => {
      if (e.key === "Escape" && this.state.showArchiveModal && !this.state.archiving) this.closeArchiveModal();
    };
    document.addEventListener("keydown", this._onKeyDown);
  }

  componentWillUnmount() {
    if (this._onKeyDown) document.removeEventListener("keydown", this._onKeyDown);
  }

  loadWeights = async () => {
    const r = await getScoreWeights(auth.getAccount(), auth.getToken());
    if (r && r.data && r.data.status === 200 && r.data.data) {
      this.setState({ weights: r.data.data, weightsLoaded: true });
    }
  };

  loadStages = async () => {
    const r = await listStages(auth.getAccount(), auth.getToken());
    if (r && r.data && r.data.status === 200) {
      this.setState({ stages: (r.data.data || []).filter(function (s) { return s.active === 1 || s.active === undefined; }) });
    }
  };

  moveStage = async (stage) => {
    const { lead, onStageChanged, onToast } = this.props;
    if (lead.stage_key === stage.stage_key) return;
    this.setState({ movingTo: stage.stage_key });
    const r = await updateStage(auth.getAccount(), auth.getToken(), {
      lead_id: lead.id, stage_key: stage.stage_key, expected_updated_at: lead.updated_at || null,
    });
    this.setState({ movingTo: null });
    if (!r || !r.data) { if (onToast) onToast("Network error", true); return; }
    const d = r.data;
    if (d.status === 409) {
      if (onToast) onToast("Conflict — refreshing", true);
      if (onStageChanged) onStageChanged(null, true);
      return;
    }
    if (d.status !== 200) {
      if (onToast) onToast(d.message || "Failed to move stage", true);
      return;
    }
    if (onStageChanged) onStageChanged(stage.stage_key, false, d.data && d.data.prompt_convert);
  };

  openArchiveModal = () => this.setState({ showArchiveModal: true });
  closeArchiveModal = () => { if (!this.state.archiving) this.setState({ showArchiveModal: false }); };

  confirmArchive = async () => {
    const { lead, onToast, onArchived } = this.props;
    this.setState({ archiving: true });
    const r = await archiveLead(auth.getAccount(), auth.getToken(), lead.id);
    this.setState({ archiving: false, showArchiveModal: false });
    if (r && r.data && r.data.status === 200) {
      if (onToast) onToast("Lead archived", false);
      if (onArchived) onArchived();
    } else {
      if (onToast) onToast("Archive failed", true);
    }
  };


  renderArchiveModal() {
    const { lead } = this.props;
    const { showArchiveModal, archiving } = this.state;
    if (!showArchiveModal || typeof document === "undefined") return null;
    const modal = (
      <div
        style={{
          position: "fixed", inset: 0, background: "rgba(15,14,13,0.45)",
          zIndex: 100000, display: "flex", alignItems: "center",
          justifyContent: "center", padding: 24,
        }}
        onClick={this.closeArchiveModal}
      >
        <div
          style={{
            background: "#fff", borderRadius: 16,
            boxShadow: "0 24px 48px rgba(0,0,0,0.14),0 8px 16px rgba(0,0,0,0.08)",
            width: "100%", maxWidth: 420, overflow: "hidden",
          }}
          onClick={function(e) { e.stopPropagation(); }}
        >
          <div style={{ padding: "22px 26px 18px", borderBottom: "1px solid #E2DFD9", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 14 }}>
            <div>
              <div style={{ fontSize: 16, fontWeight: 700, color: "#1C1B19", marginBottom: 2 }}>Archive Lead</div>
              <div style={{ fontSize: 12.5, color: "#6B6860" }}>This action cannot be undone.</div>
            </div>
            <div onClick={this.closeArchiveModal} style={{ width: 28, height: 28, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#9A9690", cursor: "pointer", flexShrink: 0 }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="15" height="15"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div style={{ padding: "18px 26px" }}>
            <p style={{ margin: 0, fontSize: 14, color: "#312F2D", lineHeight: 1.6 }}>
              Are you sure you want to archive <strong>{lead ? lead.company : "this lead"}</strong>? It will be hidden from the pipeline and can be restored from the archive view.
            </p>
          </div>
          <div style={{ padding: "12px 26px 22px", display: "flex", justifyContent: "flex-end", gap: 10, borderTop: "1px solid #E2DFD9" }}>
            <button
              className="ld-field-btn ld-field-btn-cancel"
              type="button"
              onClick={this.closeArchiveModal}
              disabled={archiving}
            >Cancel</button>
            <button
              type="button"
              onClick={this.confirmArchive}
              disabled={archiving}
              style={{
                padding: "6px 16px", borderRadius: 6, border: "none",
                background: archiving ? "#fca5a5" : "#B02A2A",
                color: "#fff", fontWeight: 600, fontSize: 13, cursor: archiving ? "not-allowed" : "pointer",
              }}
            >{archiving ? "Archiving…" : "Archive Lead"}</button>
          </div>
        </div>
      </div>
    );

    return ReactDOM.createPortal(modal, document.body);
  }

  renderScore() {
    const { lead } = this.props;
    const score = Number(lead.score) || 0;
    const band = scoreBand(score);
    const breakdown = safeJson(lead.score_breakdown, null) || {};
    const weights = this.state.weights;
    const keys = ["engagement", "deal_value", "stage_progression", "activity_recency", "priority"];
    return (
      <div className="ld-side-card">
        <div className="ld-side-card-hdr">⚡ Lead Score</div>
        <div className="ld-side-card-body">
          <div className="ld-score-big" style={{ color: band.color }}>{score}</div>
          <div className="ld-score-label" style={{ color: band.color }}>
            {band.emoji ? band.emoji + " " : ""}{band.label}
          </div>
          <div className="ld-score-bar">
            <div className="ld-score-bar-fill" style={{ width: score + "%", background: band.color }} />
          </div>
          <div className="ld-score-factors">
            {keys.map((k) => {
              const raw = Number(breakdown[k]) || 0;
              const w = weights[k] || 0;
              const subBand = scoreBand(raw);
              return (
                <div className="ld-score-factor-row" key={k}>
                  <div className="ld-score-factor-top">
                    <span className="ld-score-factor-lbl">{FACTOR_LABELS[k]}</span>
                    <span className="ld-score-factor-val">
                      {raw}<span style={{ color: "#d1d5db" }}>/100</span>
                      <span style={{ margin: "0 4px", color: "#d1d5db" }}>·</span>
                      <span className="ld-score-factor-wt">{w}%</span>
                    </span>
                  </div>
                  <div className="ld-score-factor-bar">
                    <div className="ld-score-factor-bar-fill"
                      style={{ width: raw + "%", background: subBand.color }} />
                  </div>
                </div>
              );
            })}
          </div>
          {lead.score_source && lead.score_source !== "formula" ? (
            <div style={{ marginTop: 10, fontSize: 11, color: "#6b7280", fontStyle: "italic", textAlign: "center" }}>
              Source: {lead.score_source}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  render() {
    const { lead, onConvert } = this.props;
    const { stages, movingTo } = this.state;
    return (
      <aside className="ld-side ld-side-right">
        <div className="ld-side-card">
          <div className="ld-side-card-hdr">⏱ Quick Actions</div>
          <div className="ld-side-card-body" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <button className="btn btn-primary" style={{ color: "#fff", width: "100%", justifyContent: "center" }} onClick={onConvert}><em className="icon ni ni-plus"></em>&nbsp;Add as Client</button>
            <button className="ld-btn-outline" style={{ width: "100%", justifyContent: "center" }} onClick={this.openArchiveModal}>📦 Archive</button>
          </div>
        </div>

        <div className="ld-side-card">
          <div className="ld-side-card-hdr">🎯 Move Stage</div>
          <div className="ld-side-card-body">
            <div className="ld-move-stages">
              {stages.map((s) => {
                const isOn = lead.stage_key === s.stage_key;
                const color = s.color_hex || "#1c5bde";
                return (
                  <button key={s.stage_key}
                    className={"ld-move-stage" + (isOn ? " ld-move-stage-on" : "")}
                    style={{ "--stage-color": color, minWidth: 0 }}
                    disabled={movingTo === s.stage_key}
                    onClick={() => this.moveStage(s)}
                    title={s.label}>
                    <span className="ld-move-stage-num">
                      {s.is_won ? "✓" : s.is_lost ? "✕" : (s.sort_order || "")}
                    </span>
                    <span
                      className="ld-move-stage-lbl"
                      style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, minWidth: 0, textAlign: "left" }}
                    >{s.label}</span>
                  </button>
                );
              })}
              {stages.length === 0 ? <div style={{ fontSize: 12, color: "#9ca3af" }}>Loading stages…</div> : null}
            </div>
          </div>
        </div>

        {this.renderScore()}
        {this.renderArchiveModal()}
      </aside>
    );
  }
}
